import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const Icon: React.FC<SvgProps> = (props) => {
  const { width, height } = props
  return (
    <Svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="white" />
      <g clipPath="url(#clip0_6943_51587)">
        <path
          d="M15.7397 9.54298C15.477 9.39287 15.1392 9.39287 14.839 9.54298L12.7375 10.7814L11.3115 11.5694L9.24755 12.8078C8.98486 12.9579 8.64713 12.9579 8.34691 12.8078L6.73327 11.8321C6.47058 11.682 6.28295 11.3818 6.28295 11.044V9.16771C6.28295 8.8675 6.43305 8.56729 6.73327 8.37965L8.34691 7.44149C8.6096 7.29138 8.94734 7.29138 9.24755 7.44149L10.8612 8.41718C11.1239 8.56729 11.3115 8.8675 11.3115 9.20524V10.4436L12.7375 9.61803V8.34213C12.7375 8.04191 12.5874 7.7417 12.2872 7.55407L9.28508 5.79031C9.02239 5.64021 8.68465 5.64021 8.38444 5.79031L5.30725 7.59159C5.00704 7.7417 4.85693 8.04191 4.85693 8.34213V11.8696C4.85693 12.1698 5.00704 12.4701 5.30725 12.6577L8.34691 14.4214C8.6096 14.5716 8.94734 14.5716 9.24755 14.4214L11.3115 13.2206L12.7375 12.395L14.8015 11.1942C15.0642 11.044 15.4019 11.044 15.7021 11.1942L17.3158 12.1323C17.5785 12.2824 17.7661 12.5826 17.7661 12.9204V14.7967C17.7661 15.0969 17.616 15.3971 17.3158 15.5848L15.7397 16.5229C15.477 16.673 15.1392 16.673 14.839 16.5229L13.2254 15.5848C12.9627 15.4347 12.7751 15.1344 12.7751 14.7967V13.5959L11.349 14.4214V15.6598C11.349 15.96 11.4992 16.2603 11.7994 16.4479L14.839 18.2116C15.1017 18.3617 15.4394 18.3617 15.7397 18.2116L18.7793 16.4479C19.042 16.2978 19.2296 15.9976 19.2296 15.6598V12.0948C19.2296 11.7946 19.0795 11.4944 18.7793 11.3067L15.7397 9.54298Z"
          fill="#8247E5"
        />
      </g>
      <defs>
        <clipPath id="clip0_6943_51587">
          <rect width="14.4102" height="12.5714" fill="white" transform="translate(4.85693 5.71484)" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default Icon
